import { render, staticRenderFns } from "./discount-detail.vue?vue&type=template&id=13cba14c&scoped=true"
import script from "./discount-detail.vue?vue&type=script&lang=js"
export * from "./discount-detail.vue?vue&type=script&lang=js"
import style0 from "./discount-detail.vue?vue&type=style&index=0&id=13cba14c&prod&lang=scss&scoped=true"
import style1 from "./discount-detail.vue?vue&type=style&index=1&id=13cba14c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cba14c",
  null
  
)

export default component.exports